import axios from 'axios';
import Cookies from 'js-cookie';
import { baseUrl } from './config';

const axiosInstance = axios.create({
    baseURL: `${baseUrl}`,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true
});

axiosInstance.interceptors.request.use((config) => {
    const token = Cookies.get('jwt');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default axiosInstance;
